import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Mail, MapPin, Globe } from 'lucide-react';

const Contact = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 min-h-[60vh] flex items-center">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c"
            alt="Dubai Business District"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#003840]/65 via-[#003840]/55 to-[#003840]/65"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 animate-float">
              {t.contact.title}
            </h1>
            <p className="text-xl text-gray-100 max-w-2xl mx-auto animate-fade-in">
              {t.contact.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info + Ready to Connect - 2 Columns */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Left Column - Email & Address */}
            <div className="space-y-8">
              {/* Email */}
              <div className="bg-[#F4F7F6] p-8 rounded-2xl hover:shadow-xl transition-all duration-300">
                <div className="p-4 bg-white rounded-lg inline-block mb-4">
                  <Mail className="h-8 w-8 text-[#007369]" />
                </div>
                <h3 className="text-2xl font-bold text-[#003840] mb-3">{t.contact.email}</h3>
                <a
                  href="mailto:contact@ariamea.com"
                  className="text-lg text-[#007369] hover:text-[#005A5B] transition-colors font-medium"
                >
                  contact@ariamea.com
                </a>
              </div>

              {/* Address */}
              <div className="bg-[#F4F7F6] p-8 rounded-2xl hover:shadow-xl transition-all duration-300">
                <div className="p-4 bg-white rounded-lg inline-block mb-4">
                  <MapPin className="h-8 w-8 text-[#007369]" />
                </div>
                <h3 className="text-2xl font-bold text-[#003840] mb-3">{t.contact.address}</h3>
                <p className="text-lg text-gray-600">{t.contact.addressValue}</p>
              </div>
            </div>

            {/* Right Column - Ready to Connect */}
            <div>
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-[#003840] mb-4">
                  {t.contact.readyToConnect.title}
                </h2>
                <p className="text-lg text-gray-600">
                  {t.contact.readyToConnect.subtitle}
                </p>
              </div>

              <div className="bg-[#F4F7F6] rounded-2xl p-8">
                <ul className="space-y-4 mb-8">
                  {t.contact.readyToConnect.items.map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#007369] flex items-center justify-center mt-0.5">
                        <span className="text-white text-sm font-bold">{index + 1}</span>
                      </div>
                      <span className="text-lg text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>

                <div className="text-center">
                  <a
                    href="mailto:contact@ariamea.com"
                    className="inline-block bg-[#007369] hover:bg-[#005A5B] text-white font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                  >
                    {t.contact.readyToConnect.button}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Global Presence */}
      <section className="py-20 bg-[#F4F7F6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block p-4 bg-white rounded-lg mb-6">
            <Globe className="h-12 w-12 text-[#007369]" />
          </div>
          <h3 className="text-3xl font-bold text-[#003840] mb-4">
            {t.contact.globalPresence.title}
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.contact.globalPresence.description}
          </p>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-[#F4F7F6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-12 text-center shadow-lg">
            <h3 className="text-2xl font-bold text-[#003840] mb-4">
              {t.contact.basedIn.title}
            </h3>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;